// Only return to an in-app page, never to another auth screen or an external URL.
export const getLoginReturnTo = (state: unknown): string => {
  const returnTo = (state as { returnTo?: unknown } | null)?.returnTo;
  if (typeof returnTo !== "string" || !returnTo.startsWith("/") ||
      returnTo.startsWith("//") || /[\\\s]/.test(returnTo)) return "/";

  const pathname = returnTo.split(/[?#]/)[0].replace(/\/+$/, "").toLowerCase();
  return ["/login", "/register", "/resetpassword"].includes(pathname) ? "/" : returnTo;
};
